import "components/carousels/JsCarousel.js";
import {BrandCarouselLandsCapeBreakpoints} from "./settings/BreakpointSettings";

export default function (customOptions = {}) {
    let wrapper = customOptions.parentContainer ? customOptions.parentContainer : $('.generic-carousel');

    let defaultOptions = {
        responsive: BrandCarouselLandsCapeBreakpoints
    };

    let endOptions = $.extend(defaultOptions, customOptions.options);
    wrapper.JsCarousel(endOptions);
}
